import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { NavigationEnd, Router } from '@angular/router';

import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { MerchantBasicDataViewModel } from '@app/api/marketplace/models';
import { UserService } from '@authentication/services/user.service';
import { MerchantSelectors } from '@merchant/store/merchant.slice';
import { ProductSearchActions } from '@search/store/search.slice';
import {
  MenuItem,
  sideNavAdminItems,
  sideNavItems,
  sideNavTelesalesItems,
} from '@shared/interfaces/sidenav';

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
})
export class SidenavMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('expPanels', { read: ElementRef<HTMLInputElement> })
  panels!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChildren(MatExpansionPanel) matPanels!: QueryList<MatExpansionPanel>;

  basicData!: MerchantBasicDataViewModel;
  roles: string[] = [];
  isRetailer = false;
  retailerMenuItems: MenuItem[] = [];

  hasBasicData$ = this.store.select(MerchantSelectors.selectBasicData);
  isBasicDataLoading$ = this.store.select(MerchantSelectors.isBasicDataLoading);

  private subs = new SubSink();

  url = '';
  activeMenuUrl = '';
  selectedSegment = '';

  get menuItems(): MenuItem[] {
    // TODO szebben
    return this.roles.includes('EASYLOT_ADMIN') ||
      this.roles.includes('IMPERSONATION')
      ? sideNavAdminItems
      : this.roles.includes('TELESALES')
      ? sideNavTelesalesItems
      : this.isRetailer
      ? this.retailerMenuItems
      : sideNavItems;
  }

  constructor(
    public authenticator: AuthenticatorService,
    private readonly userService: UserService,
    private readonly store: Store,
    private readonly router: Router
  ) {}

  ngOnInit() {
    // kiskernek nincs értékesítés menü
    this.retailerMenuItems = structuredClone(sideNavItems);
    this.retailerMenuItems.splice(2, 1);
    this.setActiveMenuUrl();

    this.subs.sink = this.userService.currentUserRoles.subscribe((roles) => {
      if (roles && JSON.stringify(roles) !== JSON.stringify(this.roles)) {
        this.roles = roles;
        setTimeout(() => {
          this.onMenuItemChange(this.router.url);
        });
      }
    });

    this.subs.sink = this.hasBasicData$.subscribe((res) => {
      if (res) {
        this.basicData = res;
        this.isRetailer =
          !!this.basicData.highestMerchantType?.includes('RETAILER');
      }
    });

    this.subs.sink = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.onMenuItemChange(e.url);
        this.setActiveMenuUrl();
      }
    });
  }

  ngAfterViewInit(): void {
    this.onMenuItemChange(this.router.url);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setActiveMenuUrl() {
    if (!this.router.url.includes('products-start')) {
      this.activeMenuUrl = this.router.url;
    } else {
      this.activeMenuUrl = this.router.url.replace(
        'products-start',
        'products'
      );
    }
  }

  onMenuItemChange(routerLink: string) {
    this.panels.forEach((panel, idx) => {
      if (!routerLink.startsWith('/' + panel.nativeElement.id)) {
        this.matPanels.toArray()[idx].close();
      } else {
        this.matPanels.toArray()[idx].open();
      }
    });
  }
}
